import { ConfirmDialog } from 'primereact/confirmdialog';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheck, faXmark } from "@fortawesome/free-solid-svg-icons";
import { Button } from 'primereact/button';

const BackModal = (props) => {

    const handleAccept = () => {
        props.onConfirm?.();
    };

    const handleReject = () => {
        props.onHide?.();
    };

    const acceptLabel = (
        <div style={{ color: 'white' }}>
            <FontAwesomeIcon icon={faCheck} />&nbsp; Yes
        </div>
    );

    const rejectLabel = (
        <div>
            <FontAwesomeIcon icon={faXmark} />&nbsp; No
        </div>
    );

    return (
        <ConfirmDialog
            group="headless"
            visible={props.show}
            onHide={props.onHide}
            closable={false}
content={({ headerRef, contentRef, footerRef }) => (
                <div
                    style={{
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        padding: '2rem',
                        backgroundColor: '#fff',
                        borderRadius: '12px',
                        boxShadow: '0 0 10px rgba(0,0,0,0.15)',
                        textAlign: 'center',
                    }}
                >
                    <div
                        style={{
                            backgroundColor: '#0d6efd',
                            color: 'white',
                            width: '106px',
                            height: '106px',
                            borderRadius: '50%',
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                            marginTop: '-78px',
                            fontSize: '3rem',
                        }}
                    >
                        <i className="pi pi-question" style={{ fontSize: '2.5rem' }} />
                    </div>

                    <div ref={headerRef} style={{ fontSize: '1.5rem', fontWeight: 'bold', marginTop: '1rem' }}>
                        Confirmation
                    </div>
                    <p ref={contentRef} style={{ marginTop: '1rem', fontSize: '1rem' }}>
                        {props.children}
                    </p>
                    <div ref={footerRef} style={{ display: 'flex', gap: '1rem', marginTop: '1rem' }}>
                        <Button
                            label={rejectLabel}
                            outlined
                            style={{ width: '6rem' }}
                            onClick={handleReject}
                        />
                        <Button
                            label={acceptLabel}
                            style={{ border: 'none', width: '6rem' }}
                            onClick={handleAccept}
                        />
                    </div>
                </div>
            )}
            className="custom-confirm-dialog"
        />
    );
};

export default BackModal;
